import { DownArrow, DragIcon, UpArrow } from 'assests/GmsIcons';
import React, { useEffect, useState } from 'react';
import { SUB_MODEL } from 'Pages/GMS/ISR/ISRConstants';
import SubmodleFieldItem from './SubmodleFieldItem';
import {TField, TSubmodel, TProductCategory, TConnector } from '../../DefineModel/model';
import { toast } from 'react-toastify';
import { TDataModel, TUIBuilder, TUIModel } from '../ui';
import { Draggable } from "react-beautiful-dnd";

type SubModelItemProps = {
    dragHandleProps: any;
    submodel: TSubmodel;
    collapseAll: boolean;
    uiModelProjectData: TUIModel;
    activeTabIndex: number;
    setUiModelProjectData: React.Dispatch<React.SetStateAction<TUIBuilder>>;
}

const SubModelItem = ({dragHandleProps, submodel, uiModelProjectData, setUiModelProjectData, activeTabIndex, collapseAll}: SubModelItemProps) => {
    const [collapse, setCollapse] = useState(false);
    //const submodelMap = submodel.data.fields
    
    const handleCollapse = () => {
        setCollapse((prev) => prev = !prev);
    }
  
    useEffect(() => {
        setCollapse(collapseAll);
    }, [collapseAll]);

    const convertSubmodelToUiDefinition = (dataModelId: string) => {
        return
        /*
        const maxRank = Math.max(...uiModelProjectData.pages[activeTabIndex].dataModels.map((dataModel) => dataModel.rank), 0);

        if (!uiModelProjectData.pages[activeTabIndex].dataModels.some((dataModel) => dataModel.id === dataModelId)) {
            const newDataModel: TDataModel = {
                id: dataModelId,
                rank: maxRank + 1,       
                submodelName: submodel?.data?.name ?? '',
                fields: [],
                categories: [],
                connectors: [],
            };

            if (submodel?.data?.fields && submodel.data.fields.length > 0) {
                newDataModel.fields = submodel.data.fields.map((field, index) => ({
                    id: field?.id ?? '',
                    rank: index + 1,
                    fieldType: '',
                    modelFieldType: field?.type ?? '',
                    fieldName: field?.name ?? '',
                    enableCondition: false,
                    isFieldVisible: true,
                    conditionState: '',
                    fieldTargetSelection: '',
                    answerTargetSelection: '',
                }));
            }
        
            if (submodel?.data?.productCategories && submodel?.data?.productCategories.length > 0) {
                newDataModel.categories = submodel?.data?.productCategories.map((category, index) => ({
                    id: category.id ?? '',
                    rank: index + 1,
                    categoryName: category?.data?.name ?? '',
                    isCategoryVisible: true,
                }));
            }

            if (submodel?.data?.connectors && submodel?.data?.connectors.length > 0) {
                newDataModel.connectors = submodel?.data?.connectors.map((connector, index) => ({
                    id: connector?.id ?? '',
                    rank: index + 1,
                    connectorName: connector?.data?.name ?? '',
                    isConnectorVisible: true,
                }));
            }

            setUiModelProjectData((prevUiModel) => {
                const updatedPages = [...prevUiModel.pages];
                
                updatedPages[activeTabIndex] = {
                    ...updatedPages[activeTabIndex],
                    dataModels: [...updatedPages[activeTabIndex].dataModels, newDataModel],
                };
            
                return {
                    ...prevUiModel,
                    pages: updatedPages,
                };
            });
        } else {
            toast.info("You've already added this model");
        }
        */
    };

    const convertSubmodelItemToUiDefinition = (fieldIdentifier: string, field: TField | TProductCategory | TConnector ) => {
        return
        /*
        let uiDataModels: TDataModel[] = uiModelProjectData.pages[activeTabIndex].dataModels
        let currentDataModelIndex: number = uiModelProjectData.pages[activeTabIndex].dataModels.findIndex((dataModel) => dataModel.id === submodel?.id)
         
        if(currentDataModelIndex>=0){
 
            if (fieldIdentifier==="field" && submodel?.data?.fields && submodel.data.fields.length > 0) {
                
                let fieldIndex = uiDataModels[currentDataModelIndex].fields.findIndex((i => i.id === (field as any).id))
                
                if(fieldIndex >= 0){
                    toast.info("Field already added to Model");
                }
                else{
                    uiDataModels[currentDataModelIndex]?.fields.push({
                        id: field?.id ?? '',
                        rank: submodel?.data?.fields.length,
                        fieldType: '',
                        modelFieldType: field?.type ?? '',
                        fieldName: (field as any).name ?? '',
                        enableCondition: false,
                        isFieldVisible: true,
                        conditionState: '',
                        fieldTargetSelection: '',
                        answerTargetSelection: '',
                    });
                }
            }
        
            if (fieldIdentifier==="category" && submodel?.data?.productCategories && submodel?.data?.productCategories.length > 0) {
                let categoryIndex = uiDataModels[currentDataModelIndex].categories.findIndex((i => i.id === (field as any).id))
                
                if(categoryIndex >= 0){
                    toast.info("Category already added to Model");
                }
                else{
                    uiDataModels[currentDataModelIndex].categories.push({
                        id: field?.id ?? '',
                        rank: submodel?.data?.productCategories.length,
                        categoryName: (field as any).data.name ?? '',
                        isCategoryVisible: true,
                    });
                }
            }

            if (fieldIdentifier==="connector" && submodel?.data?.connectors && submodel?.data?.connectors.length > 0) {
                
                let connectorIndex = uiDataModels[currentDataModelIndex].connectors.findIndex((i => i.id === (field as any).id))
                
                if(connectorIndex >= 0){
                    toast.info("Conenctor already added to Model");
                }
                else{
                    uiDataModels[currentDataModelIndex].connectors.push({
                        id: field?.id ?? '',
                        rank: submodel?.data?.connectors.length,
                        connectorName: (field as any).data.name ?? '',
                        isConnectorVisible: true,
                    });
                }
            }

            setUiModelProjectData((prevUiModel) => {
                const updatedPages = [...prevUiModel.pages];
            
                updatedPages[activeTabIndex] = {
                    ...updatedPages[activeTabIndex],
                    dataModels: uiDataModels,
                };
            
                return {
                    ...prevUiModel,
                    pages: updatedPages,
                };
            });
        } else {
            toast.info("Please add the model first");
        }
        */
    };

    return (
        <React.Fragment >
            <div  className='tw-rounded tw-bg-[#f9fbfe] tw-box-border tw-w-full tw-h-auto tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-mt-3'>
                <div onClick={() => {}} className={`tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-auto tw-flex tw-flex-row tw-items-center tw-justify-between  tw-py-[3px] tw-px-3 tw-gap-[12px] tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-text-shades-of-grey-60`}>
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div {...dragHandleProps}>
                            <DragIcon/>
                        </div>
                        <div >
                            <label className='tw-text-xs tw-block'>{submodel?.data?.name ?? ''}</label>
                            <label className='tw-text-xs tw-text-[#747593] tw-block'>{SUB_MODEL}</label>
                        </div>
                    </div>
                    <div className='tw-flex tw-items-center tw-gap-5 '>
                        {/*<button onClick={() => convertSubmodelToUiDefinition(submodel?.id ?? '')} className='tw-text-primary'>Add</button>*/}
                        <div onClick={handleCollapse} className='tw-rounded tw-bg-gainsboro-100 tw-w-6 tw-h-6 tw-flex tw-flex-col tw-items-center tw-justify-center'>
                            {!collapse ? <UpArrow /> : <DownArrow />}
                        </div>
                    </div>
                </div>
                
                {!collapse ? 
                    <div>
                        {submodel?.data?.fields.length > 0 ? submodel?.data?.fields?.map((field) =>
                                    <Draggable key={`_${field.id}`} draggableId={`${JSON.stringify({...field, subModelId: submodel.id})}`} index={-1}>
                                        {(provided, snapshot) => (
                                            <div ref={provided.innerRef} {...provided.draggableProps} className='tw-mx-2 tw-my-2'>
                                                <SubmodleFieldItem dragHandleProps={provided.dragHandleProps} fieldName={field?.name} fieldType={field?.type} />
                                            </div>
                                        )}
                                    </Draggable>
                                ) : null}
                    </div>
                : null}

                {!collapse ? 
                    <div>
                        {submodel?.data?.productCategories && submodel?.data?.productCategories.length > 0 ? submodel?.data?.productCategories.map((field, fieldIndex) => 
                            <div key={field?.id} className='tw-mx-2 tw-my-2'>
                                <SubmodleFieldItem field={field} fieldName={field?.data?.name} fieldType={field?.type} fieldIdentifier={"category"} fieldAddition={convertSubmodelItemToUiDefinition} addField={false} />   
                            </div>
                        ) : null} 
                    </div>
                : null} 

                {!collapse ? 
                    <div>
                        {submodel?.data?.connectors && submodel?.data?.connectors.length > 0 ? submodel?.data?.connectors.map((connector, connectorIndex) => 
                            <div key={connector?.id} className='tw-mx-2 tw-my-2'>
                                <SubmodleFieldItem field={connector} fieldName={connector?.data?.name} fieldType={connector?.type} fieldIdentifier={"connector"} fieldAddition={convertSubmodelItemToUiDefinition} addField={false} />   
                            </div>
                        ) : null} 
                    </div>
                : null}     
            </div>
        </React.Fragment>
    );
}

export default SubModelItem;